import React, { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import { blue } from '../../color'
import {
  BarChartOutlined,
  CalendarOutlined,
  FormOutlined,
  HddOutlined,
  ProfileOutlined,
  SnippetsOutlined,
  ShareAltOutlined,
  ImportOutlined,
  ExportOutlined,
  SendOutlined,
  MessageOutlined,
  BellOutlined,
} from '@ant-design/icons'
import { MODULE_CODE } from '../../constants'
import { Button, message } from 'antd'
import NotiPermissionStore from '../../stores/NotiPermissionStore'
import {
  ModuleChildrenItemWrapper,
  ModuleParentItemWrapper,
} from '../ModulePage/ModulePageStyled'
import Checkbox from 'antd/es/checkbox/Checkbox'

const styleIcon = { marginRight: 10, color: blue, fontSize: 16 }
const renderIcon = type => {
  if (type === MODULE_CODE.lich_co_quan) {
    return <CalendarOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.nhiem_vu) {
    return <ProfileOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.cong_viec) {
    return <SnippetsOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.bang_luong) {
    return <BarChartOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.hanh_chinh) {
    return <HddOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.van_ban_den) {
    return <ImportOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.van_ban_di) {
    return <ExportOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.phat_hanh_van_ban) {
    return <SendOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.duyet_luong) {
    return <FormOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.tin_nhan_noi_bo_di) {
    return <MessageOutlined style={styleIcon} />
  }
  if (type === MODULE_CODE.thong_bao_chung) {
    return <BellOutlined style={styleIcon} />
  }
}

const NotiPermission = props => {
  const [isLoading, setIsLoading] = useState(false)
  const [notiPermissionMenu, setNotiPermissionMenu] = useState([
    {
      code: 'lich_co_quan',
      name: 'Lịch cơ quan',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'WORK_SCHEDULE',
          name: 'Tạo  lịch cơ quan',
          status: false,
          parent_code: 'cơ quan',
        },
        {
          code: 'WORK_SCHEDULE_UPDATE',
          name: 'Chỉnh sửa lịch cơ quan',
          status: false,
          parent_code: 'cơ quan',
        },
      ],
    },
    {
      code: 'van_ban_den',
      name: 'Văn bản đến',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'INCOMING',
          name: 'Tạo và xử lý văn bản đến',
          status: false,
          parent_code: 'van_ban_den',
        },
      ],
    },
    {
      code: 'van_ban_di',
      name: 'Văn bản đi',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'OUTGOING',
          name: 'Xử lý văn bản đi',
          status: false,
          parent_code: 'van_ban_di',
        },
      ],
    },
    {
      code: 'phat_hanh_van_ban',
      name: 'Phát hành văn bản',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'ELEC_DOC',
          name: 'Tạo phát hành văn bản',
          status: false,
          parent_code: 'phat_hanh_van_ban',
        },
      ],
    },
    {
      code: 'nhiem_vu',
      name: 'Nhiệm vụ',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'TASK',
          name: 'Tạo nhiệm vụ',
          status: false,
          parent_code: 'nhiem_vu',
        },
      ],
    },
    {
      code: 'cong_viec',
      name: 'Công việc',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'WORK',
          name: 'Tạo công việc, thêm người và lấy ý kiến',
          status: false,
          parent_code: 'cong_viec',
        },
        {
          code: 'WORK_UPDATE',
          name: 'Chỉnh sửa công việc',
          status: false,
          parent_code: 'cong_viec',
        },
      ],
    },
    {
      code: 'duyet_luong',
      name: 'Duyệt lương',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'PROPOSAL_SALARY',
          name: 'Tạo duyệt lương',
          status: false,
          parent_code: 'duyet_luong',
        },
      ],
    },
    {
      code: 'hanh_chinh',
      name: 'Hành chính',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'BUSINESS_TRIP',
          name: 'Tạo hành chính',
          status: false,
          parent_code: 'hanh_chinh',
        },
        {
          code: 'PROPOSAL_ASSET',
          name: 'Tạo phiếu phân phát VPP',
          status: false,
          parent_code: 'phieu_phan_phap_vpp',
        },
      ],
    },
    {
      code: 'tin_nhan_noi_bo_di',
      name: 'Tin nhắn nội bộ đi',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'INTERNAL_MESSAGE_INCOMING',
          name: 'Tạo tin nhắn nội bộ đi',
          status: false,
          parent_code: 'tin_nhan_noi_bo_di',
        },
      ],
    },
    {
      code: 'thong_bao_chung',
      name: 'Thông báo chung',
      parent_code: null,
      status: false,
      sub_modules: [
        {
          code: 'NEWS',
          name: 'Tạo thông báo chung',
          status: false,
          parent_code: 'thong_bao_chung',
        },
        {
          code: 'NEWS_UPDATE',
          name: 'Chỉnh sửa thông báo chung',
          status: false,
          parent_code: 'thong_bao_chung',
        },
      ],
    },
  ])

  useEffect(() => {
    ;(async () => {
      try {
        const activeModuleList = await NotiPermissionStore.getNotiPermissionContent()
        setNotiPermissionMenu(
          updateModuleStatus(notiPermissionMenu, activeModuleList.split(','))
        )
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  const updateModuleStatus = (modules, activeModules) => {
    return modules.map(module => {
      let hasActiveSubModule = false

      module.sub_modules = module.sub_modules.map(subModule => {
        const isActive = activeModules.includes(subModule.code)
        if (isActive) {
          hasActiveSubModule = true
        }
        return {
          ...subModule,
          status: isActive,
        }
      })

      return {
        ...module,
        status: hasActiveSubModule,
      }
    })
  }

  const handleChangeCheckBoxParent = parentCode => {
    const newModuleList = [...notiPermissionMenu]

    const parentIndex = newModuleList.findIndex(
      item => item.code === parentCode
    )
    if (parentIndex !== -1) {
      newModuleList[parentIndex].status = !newModuleList[parentIndex].status

      if (newModuleList[parentIndex].status) {
        newModuleList[parentIndex].sub_modules.forEach(
          item => (item.status = true)
        )
      } else {
        newModuleList[parentIndex].sub_modules.forEach(
          item => (item.status = false)
        )
      }
    }
    setNotiPermissionMenu(newModuleList)
  }

  const handleChangeCheckBoxChildren = (childCode, parentCode) => {
    const newModuleList = [...notiPermissionMenu]

    const parentIndex = newModuleList.findIndex(
      item => item.code === parentCode
    )
    if (parentIndex !== -1) {
      const childIndex = newModuleList[parentIndex].sub_modules.findIndex(
        sub => sub.code === childCode
      )
      if (childIndex !== -1) {
        // Cập nhật trạng thái của module con
        newModuleList[parentIndex].sub_modules[
          childIndex
        ].status = !newModuleList[parentIndex].sub_modules[childIndex].status

        // Nếu module con được chọn, module cha sẽ được chọn
        if (newModuleList[parentIndex].sub_modules[childIndex].status) {
          newModuleList[parentIndex].status = true
        } else {
          // Nếu tất cả các module con đều không được chọn, module cha sẽ bị bỏ chọn
          const allSubModulesUnchecked = newModuleList[
            parentIndex
          ].sub_modules.every(sub => !sub.status)
          if (allSubModulesUnchecked) {
            newModuleList[parentIndex].status = false
          }
        }
      }
    }
    setNotiPermissionMenu(newModuleList)
  }

  const handleUpdateNotiPermission = async () => {
    try {
      setIsLoading(true)
      const activeSubModule = notiPermissionMenu
        .filter(item => item.status)
        .map(
          item =>
            item.sub_modules?.filter(sub => sub.status)?.map(sub => sub.code) ||
            []
        )
      const payload = {
        content: activeSubModule?.length > 0 ? activeSubModule.join(',') : '',
      }
      await NotiPermissionStore.updateNotiPermissionContent(payload)
      message.success('Cập nhật thành công!')
      setIsLoading(false)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          textTransform: 'uppercase',
        }}>
        <div />
        <Button
          icon={<ShareAltOutlined />}
          type={'primary'}
          onClick={handleUpdateNotiPermission}
          loading={isLoading}>
          Lưu lại
        </Button>
      </div>
      <div>
        {notiPermissionMenu.map((item, index) => (
          <div key={item.code}>
            <ModuleParentItemWrapper
              checked={item.status}
              onClick={() => {
                handleChangeCheckBoxParent(item.code)
              }}>
              <div>
                {renderIcon(item.code)}
                <span>{item.name}</span>
              </div>
              <Checkbox checked={item.status} />
            </ModuleParentItemWrapper>
            <div>
              {item.sub_modules.map((el, i) => (
                <ModuleChildrenItemWrapper
                  checked={el.status}
                  onClick={() => {
                    handleChangeCheckBoxChildren(el.code, item.code)
                  }}>
                  <span
                    className={`module-name ${
                      i === item.sub_modules.length - 1 ? 'module-last' : ''
                    }`}>
                    {el.name}
                  </span>
                  <Checkbox checked={el.status} />
                </ModuleChildrenItemWrapper>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

NotiPermission.propTypes = {}

export default inject('moduleStore')(observer(NotiPermission))
